// Navigate material photos through Prestige's existing carousel. Native media
// indexes, variant selection, image zoom, videos and product forms are untouched.
(() => {
  if (window.fgMaterialGalleryBound) return;
  window.fgMaterialGalleryBound = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-fg-material-target]');
    if (!button) return;
    const gallery = button.closest('product-gallery');
    const carousel = gallery?.querySelector('.product-gallery__carousel');
    if (!carousel) return;
    await customElements.whenDefined('scroll-carousel');
    const index = carousel.cells.findIndex(cell => cell.dataset.fgMaterial === button.dataset.fgMaterialTarget);
    if (index < 0) return;
    carousel.select(index);
  });
  document.addEventListener('carousel:change', event => {
    const gallery = event.target.closest('product-gallery');
    if (!gallery) return;
    const key = event.detail?.cell?.dataset.fgMaterial || event.target.selectedCell?.dataset.fgMaterial;
    gallery.querySelectorAll('[data-fg-material-target]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.fgMaterialTarget === key));
    });
  }, true);
})();
